module.exports = __webpack_public_path__ + "static/media/6.66e37a52.mp3";